<div class="ia-copy-edit-dialog">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="dialog-header">
        <h2>Edit copy</h2>
        <fa-icon class="close" (click)="closeDialog()" [icon]="['fas', 'times']"></fa-icon>
    </div>

    <div fxLayout="row" fxLayoutGap.gt-sm="24px" fxLayout.lt-md="column" class="dialog-columns">
        <div fxFlex class="dialog-column original-column">
            <div class="column-label">ORIGINAL</div>

            <div class="field-header">
                <span class="field-label">Headline</span>
            </div>
            <mat-form-field appearance="outline" class="field-block original-field" subscriptSizing="dynamic">
                <input matInput [value]="data.originalHeadline" disabled>
            </mat-form-field>

            <div class="field-header">
                <span class="field-label">Body copy</span>
            </div>
            <mat-form-field appearance="outline" class="field-block original-field" subscriptSizing="dynamic">
                <textarea matInput rows="4" [value]="data.originalBodyCopy" disabled></textarea>
            </mat-form-field>
        </div>

        <div fxFlex class="dialog-column" [formGroup]="formGroup">
            <div class="column-label">EDITABLE</div>

            <div class="editable-field">
                <div class="field-header">
                    <span class="field-label">Headline</span>
                </div>
                <mat-form-field appearance="outline" class="field-block" subscriptSizing="dynamic">
                    <input matInput formControlName="editableHeadline">
                </mat-form-field>
            </div>

            <div class="editable-field">
                <div class="field-header">
                    <span class="field-label">Body copy</span>
                </div>
                <mat-form-field appearance="outline" class="field-block" subscriptSizing="dynamic">
                    <textarea matInput rows="4" formControlName="editableBodyCopy"></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="feedback-section" [formGroup]="formGroup">
        <div class="column-label">FEEDBACK</div>
        <p class="feedback-subtitle">Optional — help us improve future copy.</p>

        <mat-form-field appearance="outline" class="field-block" subscriptSizing="dynamic">
            <mat-label>Category</mat-label>
            <mat-select formControlName="category">
                <mat-option value="">None</mat-option>
                <mat-option *ngFor="let option of feedbackCategories" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field-block" subscriptSizing="dynamic">
            <mat-label>Feedback notes</mat-label>
            <textarea matInput rows="3" formControlName="feedbackNotes"
                placeholder="What did you change and why?"></textarea>
        </mat-form-field>
    </div>

    <mat-card-actions fxLayout="row" fxLayoutAlign="space-between center" class="dialog-actions">
        <button mat-stroked-button type="button" (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="accent" type="button" (click)="apply()"
            [disabled]="formGroup.invalid">Apply</button>
    </mat-card-actions>
</div>
